










































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import {
  composeDate,
  toDateString,
  toTimeString
} from "@/utils/asesmenIntensifDateTime";

@Component({
  components: { VCDateTimePicker }
})
export default class DataAwalSection extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any;
  @Prop({ default: false }) readonly disabled!: boolean;

  form: any = {
    tanggal_asesmen: null,
    pukul: "",
    sumber_data: "pasien",
    sumber_data_nama: "",
    sumber_data_hubungan: "",
    asal_pasien: "bangsal",
    asal_bangsal_nama: "",
    asal_tanggal: null,
    asal_jam: "",
    diagnosa_medis: "",
    keluhan_utama: "",
    riwayat_alergi_umum: ""
  };

  get tanggalJamAsesmen(): Date | null {
    return composeDate(this.form.tanggal_asesmen, this.form.pukul);
  }

  set tanggalJamAsesmen(val: Date | null) {
    this.form.tanggal_asesmen = toDateString(val);
    this.form.pukul = toTimeString(val);
  }

  get tanggalJamAsal(): Date | null {
    return composeDate(this.form.asal_tanggal, this.form.asal_jam);
  }

  set tanggalJamAsal(val: Date | null) {
    this.form.asal_tanggal = toDateString(val);
    this.form.asal_jam = toTimeString(val);
  }

  asalOptions = [
    { text: "IGD", value: "igd" },
    { text: "Kamar Operasi", value: "ok" },
    { text: "PPRI", value: "ppri" },
    { text: "Bangsal Lain", value: "bangsal" }
  ];

  created() {
    if (this.value && typeof this.value === "object") {
      this.form = { ...this.form, ...this.value };
    }
  }


  @Watch("form", { deep: true })
  onFormChange(val: any) {
    this.$emit("input", { ...val });
  }

  syncFromValue(val: any) {
    if (!val) return;
    this.form = { ...this.form, ...val };
  }
}
